import { BookingTable } from './BookingTable';

export default BookingTable;
